/**
 * Contiene un fallo al pintar en la pantalla donde ocurre, en vez de dejar que
 * desmonte el arbol entero y la aplicacion quede en blanco.
 *
 * @module presentation/components/ui/LimiteDeError
 */
import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertCircle } from 'lucide-react'

import { Button } from './Button'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

export class LimiteDeError extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[JH LUMINA] fallo al pintar la pantalla', error, info.componentStack)
  }

  private reintentar = () => {
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="flex flex-col items-center justify-center h-[60vh] text-center px-6">
        <AlertCircle className="h-12 w-12 text-[var(--destructive)] mb-4" />
        <h3 className="text-lg font-semibold text-[var(--foreground)]">
          No se pudo mostrar esta pantalla
        </h3>
        <p className="text-[var(--foreground-muted)] mt-1 max-w-md">
          El resto del sistema sigue funcionando. Si vuelve a pasar, avise con el
          detalle de abajo.
        </p>
        <pre className="mt-4 max-w-xl overflow-x-auto rounded-lg bg-[var(--secondary)] p-3 text-left text-xs text-[var(--foreground-muted)]">
          {error.message}
        </pre>
        <div className="mt-4 flex gap-2">
          <Button onClick={this.reintentar}>Reintentar</Button>
          <Button variant="outline" onClick={() => window.history.back()}>
            Volver
          </Button>
        </div>
      </div>
    )
  }
}
